import axios from './index'

const baseUrl = '/api/AiAssistant/quick-questions'
const scopeUrl = scope => `${baseUrl}/${encodeURIComponent(scope)}`

export default {
  get(scope) {
    return axios.get(scopeUrl(scope)).then(response => response.data)
  },
  save(scope, questions) {
    return axios.put(scopeUrl(scope), { questions }).then(response => response.data)
  },
  reset(scope) {
    return axios.delete(scopeUrl(scope)).then(response => response.data)
  }
}
